// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.CartPage.RelatedItemsView'
,	[
        'Utils',
		'Backbone.CollectionView',
        'Backbone',
        /*'ItemRelations.Related.Collection',*/
        'C3.ShoppingExtensions.CartPage.RelatedItemsView.Collection',
        'C3.ShoppingExtensions.CartPage.RelatedItemsView.ItemCell',
        'Tracker',
       // 'SC.Configuration',
        'item_relations_cell.tpl',
        'item_relations_row.tpl',
        'item_relations_related.tpl',
        'c3_shoppingextensions_cartpage_item_relations_row.tpl'
    ]
, function (
    Utils,
	BackboneCollectionView,
    Backbone,
    ItemRelationsRelatedCollection,
    RelatedItemsViewItemCell,
    Tracker,
    //Configuration,
    item_relations_cell_tpl,
    item_relations_row_tpl,
    item_relations_related_tpl,
    c3_shoppingextensions_cartpage_item_relations_row_tpl
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return BackboneCollectionView.extend({

		initialize: function (options) {
           var config = options.configuration
            ,   siteSettings = config.siteSettings
            ,   sitetype = siteSettings.sitetype
           
           this.configuration = config;
           this.container = options.container;

            var is_sca_advance =
            sitetype === 'ADVANCED';
            var collection = is_sca_advance
                ? new ItemRelationsRelatedCollection({ itemsIds: this.options.itemsIds, configuration : config })
                : new Backbone.Collection();
            var layout = this.options.application.getLayout();
            var self = this;

        //console.log(collection)
        var collection_models = collection.models || '';
        //console.log(collection_models)
        BackboneCollectionView.prototype.initialize.call(this, {
            collection: collection,
            viewsPerRow: Infinity,
            cellTemplate: item_relations_cell_tpl,
            //rowTemplate: item_relations_row_tpl,
            rowTemplate : c3_shoppingextensions_cartpage_item_relations_row_tpl,
            childView: RelatedItemsViewItemCell,
            template: item_relations_related_tpl,
            childViewOptions: {
                    origin: 'CartPage-RelatedItems',
                    hideArrows : collection_models.length <= 5 ? true : false,
                    application : this.application,
                    container : this.container
                }
        });

        this.view_tracked = false;

        //layout.once('afterAppendView', self.loadRelatedItems, self);

        /*if (is_sca_advance) {
            this.once('afterCompositeViewRender', this.loadRelatedItems, this);
        }*/
        if (is_sca_advance) {
            layout.once('afterAppendView', self.loadRelatedItems, self);
            layout.currentView &&
                layout.currentView.once('afterCompositeViewRender', self.loadRelatedItems, self);
        }
            
		},

		loadRelatedItems: function loadRelatedItems() {
            var self = this;
             var collection_models = this.collection.models || '';
        self.collection.fetchItems().done(function() {
            if (self.collection.length) {
                if (!self.view_tracked) {
                    Tracker.getInstance().trackProductListEvent(self.collection, 'Related Items');
                    self.view_tracked = true;
                }
            }

            self.render();

            var carousel = self.$el.find('[data-type="carousel-items-related-items"]');

            const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.configuration;

            if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }

            //console.log(collection_models.length)    
           // bxSliderDefaultsRelatedItems.controls = collection_models.length >= 5 ? true : false
            bxSliderDefaults.controls = collection_models.length >= 6 ? true : false;
            //bxSliderDefaults.slideWidth = 254;

            if(collection_models.length >= 6)
            bxSliderDefaults.slideWidth = 250;
            else
            bxSliderDefaults.slideWidth = 260;

            /*bxSliderDefaults.controls = true;*/
            bxSliderDefaults.hideControlOnEnd = true;
            bxSliderDefaults.maxSlides = 5;
            bxSliderDefaults.prevText = '<a data-click="left-click" data-action="cart-relatedview-click" class="cart-related-items carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
            bxSliderDefaults.nextText = '<a data-click="right-click" data-action="cart-relatedview-click" class="cart-related-items carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';         
                
            /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
            bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
            *///bxSliderDefaults.touchEnabled = false;
            //console.log(bxSliderDefaults)    
            bxSliderDefaults.infiniteLoop = false;     

            Utils.initBxSlider(carousel, self.configuration.bxSliderDefaults);
            if(collection_models.length <= 5){
                    $(".item-relations-cell").css('padding-left','0px')
                    $(".item-relations-related-row .bx-viewport").css('margin-left','0px')
                }
        });
    }
    });
});
